import { ChangeDetectionStrategy, Component, ElementRef, OnChanges, Renderer2 } from '@angular/core';
import { GlassHouseShelfTalkerContentViewModel } from './glass-house-shelf-talker-content-view-model';
import { ShelfTalkerCardContentComponent } from '../../shelf-talker-card-content.component';

@Component({
  selector: 'app-glass-house-shelf-talker-content',
  templateUrl: './glass-house-shelf-talker-content.component.html',
  styleUrls: ['./glass-house-shelf-talker-content.component.scss'],
  providers: [GlassHouseShelfTalkerContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseShelfTalkerContentComponent extends ShelfTalkerCardContentComponent implements OnChanges {
  constructor(
    public viewModel: GlassHouseShelfTalkerContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
